import Swiper, {
  EffectFade,
  Lazy,
  Navigation,
  Pagination,
  Thumbs,
} from "swiper";

const adjustSlideHeights = (swiper) => {
  swiper.update();
  swiper.slides.css('height', 'auto');

  let maxHeight = 0;
  swiper.slides.each(function () {
    const slideHeight = $(this).outerHeight();
    maxHeight = slideHeight > maxHeight ? slideHeight : maxHeight;
  });

  swiper.slides.css('height', maxHeight + 'px');
};

export default {
  init() {
    this.events();
    this.customCostumes();
    this.gallery1();
    this.gallery2();
    this.productSlider();
  },

  events() {
    $(".page-nav__link").on("click", (e) => {
      $(e.currentTarget)
        .addClass("active")
        .parent()
        .siblings()
        .children()
        .removeClass("active");
    });
  },

  customCostumes() {
    const wrapEl = $(".cc");
    if (!wrapEl.length) {
      return;
    }

    const swiperEl = wrapEl.find(".swiper");

    const ccSwiper = new Swiper(swiperEl[0], {
      loop: true,
      modules: [Navigation, Pagination],
      allowTouchMove: false,
      navigation: {
        prevEl: wrapEl.find(".swiper-button-prev")[0],
        nextEl: wrapEl.find(".swiper-button-next")[0],
      },
      breakpoints: {
        0: {
          allowTouchMove: true,
        },
        900: {
          allowTouchMove: false,
        }
      },
      pagination: {
        el: wrapEl.find(".swiper-pagination")[0],
        clickable: true,
        renderBullet: function (index, className) {
          const title = $(".pagination-items")
            .find(`[data-pagination-index=${index}]`)
            .html();
          return (
            '<button class="' +
            className +
            " btn btn-primary" +
            '">' +
            "<span>0" +
            (index + 1) +
            "</span>" +
            title +
            "</button>"
          );
        },
      },
    });

    ccSwiper.on("slideChange", () => {
      let leftEl = wrapEl.find(".swiper-pagination-bullet-active");
      const offset = leftEl.offset().left;

      wrapEl.find(".swiper-pagination").animate({
        scrollLeft: offset,
      });
    });
  },

  gallery1() {
    const wrapEl = $(".gallery1");
    if (!wrapEl.length) {
      return;
    }

    const swiperEl = wrapEl.find(".swiper");

    new Swiper(swiperEl[0], {
      loop: true,
      modules: [Navigation, Pagination],
      navigation: {
        prevEl: wrapEl.find(".swiper-button-prev")[0],
        nextEl: wrapEl.find(".swiper-button-next")[0],
      },
      pagination: {
        el: wrapEl.find(".swiper-pagination")[0],
        clickable: true,
      },
      breakpoints: {
        0: {
          allowTouchMove: true,
        },
        900: {
          allowTouchMove: false,
        }
      },
    });
  },

  gallery2() {
    const wrapEl = $(".gallery2");
    if (!wrapEl.length) {
      return;
    }

    $(".gallery2").each((_i, el) => {
      const wrapEl = $(el);
      const swiperEl = wrapEl.find(".swiper");

      new Swiper(swiperEl[0], {
        loop: true,
        modules: [Navigation, Pagination, Lazy],
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 3,
        },
        navigation: {
          prevEl: wrapEl.find(".swiper-button-prev")[0],
          nextEl: wrapEl.find(".swiper-button-next")[0],
        },
        pagination: {
          el: wrapEl.find(".swiper-pagination")[0],
          clickable: true,
        },
        breakpoints: {
          0: {
            allowTouchMove: true,
          },
          900: {
            allowTouchMove: false,
          }
        },
      });
    });
  },

  productSlider() {
    const wrapEl = $(".product-slider");
    if (!wrapEl.length) {
      return;
    }

    $(".product-slider").each((_i, el) => {
      const wrapEl = $(el);
      const swiperEl = wrapEl.find(".swiper");

      const swiper = new Swiper(swiperEl[0], {
        loop: true,
        modules: [Navigation, Pagination],
        navigation: {
          prevEl: wrapEl.find(".swiper-button--prev")[0],
          nextEl: wrapEl.find(".swiper-button--next")[0],
        },
        pagination: {
          el: wrapEl.find(".swiper-pagination")[0],
          clickable: true,
        },
        slidesPerView: 1,
        spaceBetween: 21,
        breakpoints: {
          600: {
            slidesPerView: 2,
            allowTouchMove: true,
          },
          900: {
            slidesPerView: 3,
            allowTouchMove: false,
          },
        },
      });

      $(window).on('resize', () => {
        adjustSlideHeights(swiper);
      });

      adjustSlideHeights(swiper);
    });

  },


  featuredProductSlider() {
    const wrapEl = $(".featured-product-slider");
    if (!wrapEl.length) {
      return;
    }

    $(".featured-product-slider").each((_i, el) => {
      const wrapEl = $(el);
      const swiperEl = wrapEl.find(".swiper");

      new Swiper(swiperEl[0], {
        autoHeight: true,
        loop: true,
        modules: [Navigation, Pagination],
        navigation: {
          prevEl: wrapEl.find(".swiper-button--prev")[0],
          nextEl: wrapEl.find(".swiper-button--next")[0],
        },
        pagination: {
          el: wrapEl.find(".swiper-pagination")[0],
          clickable: true,
        },
        breakpoints: {
          0: {
            allowTouchMove: true,
          },
          900: {
            allowTouchMove: false,
          }
        },
      });
    });
  },

  productDetailsSlider() {
    const wrapEl = $(".product-details");
    if (!wrapEl.length) {
      return;
    }

    const swiperEl = wrapEl.find(".swiper");

    new Swiper(swiperEl[0], {
      loop: true,
      modules: [Navigation, Pagination],
      navigation: {
        prevEl: wrapEl.find(".swiper-button--prev")[0],
        nextEl: wrapEl.find(".swiper-button--next")[0],
      },
      pagination: {
        el: wrapEl.find(".swiper-pagination")[0],
        clickable: true,
      },
      slidesPerView: 1,
      breakpoints: {
        0: {
          allowTouchMove: true,
        },
        900: {
          allowTouchMove: false,
        }
      },
    });
  },
};
